import { Validator, success, failure } from 'formoid';
import { TypeOf, ZodErrorMap, ZodType, input, output } from 'zod';
import { record } from '../data';
import { createErrorMap } from './error-map';

export function fromZod<T, S extends ZodType>(
  zod: S,
  errorMap: ZodErrorMap,
): Validator<T, TypeOf<S>> {
  return function (value) {
    return zod
      .safeParseAsync(value, { errorMap })
      .then((result) =>
        result.success ? success(result.data) : failure([result.error.errors[0].message]),
      );
  };
}

export type Schema<T extends Record<string, unknown>> = {
  [K in keyof T]: [string, ZodType] | null;
};

export type ToValidationSchema<T extends Schema<Record<string, unknown>>> = {
  [K in keyof T]: T[K] extends ZodType ? Validator<input<T[K]>, output<T[K]>> : null;
};

export function fromZodSchema<S extends Schema<Record<string, unknown>>>(
  schema: S,
): ToValidationSchema<S> {
  return record.fromEntries(
    record.entries(schema).map(([key, tuple]) => {
      return [key, tuple === null ? null : fromZod(tuple[1], createErrorMap(tuple[0]))];
    }),
  ) as ToValidationSchema<S>;
}
